import { exportArrayToCsv } from '@/lib/csvExport';
import { METRICS } from './fmt';

const cap = (v) => (v ? v.charAt(0).toUpperCase() + v.slice(1) : '');

/** All operations in one CSV: one row per staff per operation, with month columns. */
export const exportRankingsCsv = (data) => {
  const metric = data.rank_by;
  const short = METRICS[metric].short;
  const rows = (data.operations || []).flatMap((o) => o.rows.map((r) => ({ ...r, op: o.name, module: o.module })));
  const cols = [
    ['op', 'Operation'], ['module', 'Section'], ['rank', 'Rank'], ['staff_id', 'Staff ID'], ['staff_name', 'Staff Name'], ['section', 'Staff Section'],
    ['designation', 'Designation'], [(r) => cap(r.gender), 'Gender'], [(r) => cap(r.worker_type), 'Regular / Contract'], ['agency', 'Agency'],
    [(r) => (r.collar ? `${cap(r.collar)} Collar` : ''), 'Collar'], [(r) => cap(r.pay_type), 'Pay Type'],
    [(r) => (r.roll_status === 'left' ? 'Left' : r.roll_status === 'in_roll' ? 'In Roll' : ''), 'Roll Status'],
    ['days', 'Days Present'], ['hours', 'Hours'], [(r) => (r.hours_est ? 'Yes' : ''), 'Hours Estimated'], ['qty', 'Pieces'],
    ['per_day', 'Pcs / Day'], ['per_hour', 'Pcs / Hour'], ['target_pct', '% of Target'], ['vs_avg_pct', 'vs Op Avg %'],
    ...(data.months || []).flatMap((m) => [
      [(r) => r.months[m.key]?.value ?? '', `${m.label} ${short}`],
      [(r) => r.months[m.key]?.high?.value ?? '', `${m.label} High Day`],
      [(r) => r.months[m.key]?.low_day?.value ?? '', `${m.label} Low Day`],
      [(r) => (r.months[m.key]?.low ? 'LOW' : ''), `${m.label} Low?`],
    ]),
    ['low_months', 'Low Months'], ['max_low_streak', 'Longest Low Streak'], [(r) => (r.repeat_low ? 'YES' : ''), 'Repeat Low Performer'],
  ].map(([key, header]) => ({ key, header }));
  const sh = (data.shifts || []).find((s) => s.id === data.shift);
  const sf = Object.values(data.staff_filters || {}).map((v) => (v === data.no_base ? 'notset' : v));
  const tag = [sh && sh.name, ...sf].filter(Boolean).join('_').toLowerCase().replace(/[^a-z0-9_]+/g, '-');
  exportArrayToCsv(rows, cols, `staff_rankings_${data.date_from}_to_${data.date_to}_${metric}${tag ? `_${tag}` : ''}.csv`);
};

export default exportRankingsCsv;
